module.exports = __webpack_public_path__ + "static/img/logo.9f82e10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b122/logo.png
// module id = 9f/Q
// module chunks = 1